export default "__VITE_ASSET__xpNGNnHp__"